import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  NitroButton,
  NitroButtonGroup,
  NitroHeading,
  NitroParagraph,
  NitroLoading,
  NitroCheckbox,
  NitroTextField,
  NitroPanel
} from 'nitro-components';
import styled from 'styled-components';
import { media } from 'style-utils';

import { setPassword } from './store/action';
import formPasswordCheck from '../../utils/forms/form-password-check';
import {
  ERROR_PASSWORD,
  INFO_PASSWORD_STRENGTH
} from '../../utils/forms/const-messages';

const ShowPassword = styled.div`
  margin-top: 20px;
`;

const ActionSection = styled.div`
  margin-top: 10px;
`;

export const Container = styled.div`
  display: flex;
  ${media.desktop`
  flex-direction: row
  `} ${media.mobile`
  flex-direction: column
  `}
  justify-content: space-between;
`;

export const PasswordSection = styled.div`
  ${media.desktop`
  width: 40%
  `} ${media.mobile`
  width: 100%
  `}
  display: flex;
  flex-direction: column;
`;

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // form values stored here onChange of inputs
      formData: {
        newPassword: ''
      },

      // default validation
      formValid: {
        newPassword: true
      },

      // default state of inputs (false=password, true=input)
      // shows/hides password value
      showPassword: {
        newPassword: false
      }

      // on form submit, set to true to show loading on button
    };
    this.formData = this.formData.bind(this);
    this.showPassword = this.showPassword.bind(this);
  }

  /*
        formDataReset
        empty formData values
      */

  formDataReset = () => {
    // empty form field data
    this.setState({
      formData: {
        newPassword: ''
      },
      formValid: {
        newPassword: true
      }
    });
  };

  /*
        formDataCheckPassword
        checks password strength - method imported from utils
      */

  formDataCheckPassword = () => {
    const isValid = formPasswordCheck(this.state.formData.newPassword);

    // console.log(isValid);

    const formValid = this.state.formValid;
    formValid.newPassword = isValid.isValid;

    this.setState({ formValid });

    return isValid;
  };

  /*
        formDataCheck
        checks the length of each input value (there is only one right now)
      */

  formDataCheck = () => {
    const isValid = formPasswordCheck(this.state.formData.newPassword);
    const { formValid } = this.state;

    this.setState({ formValid });

    return isValid;
  };

  /*
        formData
        onChange event on input saves form data in local state
      */

  formData(event) {
    const { name, value } = event.target;

    const { formData } = this.state;
    formData[name] = value;

    this.setState({
      formData
    });

    // perform data validation onChange - new password
    if (!this.state.formValid.newPassword) {
      this.formDataCheckPassword(value);
    }
  }

  /*
        onBlur
        only perform validation check when the user has started to enter something
        else no error is shown
      */

  formDataCheckOnBlur = event => {
    const { name, value } = event.target;

    if (value.length > 0 && name === 'newPassword') {
      this.formDataCheckPassword();
    }
    // if (value.length > 0 && name === 'oldPassword') {
    //   this.formDataCheck();
    // }
  };

  /*
        submitChangePassword
        invoked by: form submit to api
      */

  submitChangePassword = () => {
    // check is form is valid, submit to api
    if (this.formDataCheck() && this.formDataCheckPassword()) {
      // send oldPassword & newPassword to api
      this.props.setPassword(this.state.formData.newPassword);
    }
  };

  /*
        showPassword
        invoked by: checkbox onCheck()
        name: inputName of text field to toggle input value
        true: hide input value
        false: show input value
      */

  showPassword = inputName => {
    // get showPassword
    const { showPassword } = this.state;

    // toggle showPassword
    showPassword[inputName] = !showPassword[inputName];

    // set showPassword
    this.setState({
      showPassword
    });
  };

  render() {
    // console.log('state:', this.state);
    // console.log('form valid:', this.state.formValid);
    // console.log('profile:', this.props.response);

    // show loading until profile data is returned
    if (this.props.loading) {
      return <NitroLoading screen />;
    }

    return (
      <section>
        <PasswordSection>
          <NitroTextField
            id="new-password-input"
            name="newPassword"
            floatingLabelText="New password"
            hintText="Enter your new password"
            label="New password"
            onChange={this.formData}
            onBlur={this.formDataCheckOnBlur}
            type={this.state.showPassword.newPassword ? '' : 'password'}
            errorText={this.state.formValid.newPassword ? '' : ERROR_PASSWORD}
            value={this.state.formData.newPassword}
            fullWidth
          />

          <ShowPassword>
            <NitroCheckbox
              label="Show new password"
              checked={this.state.showPassword.newPassword}
              action={() => this.showPassword('newPassword')}
            />
          </ShowPassword>

          <ActionSection>
            <NitroParagraph>{INFO_PASSWORD_STRENGTH}</NitroParagraph>
          </ActionSection>

          <ActionSection>
            <NitroButtonGroup layout="horizontal">
              <NitroButton
                size="small"
                action={this.submitChangePassword}
                label="Change password"
                variant="primary"
                disabled={this.props.loading}
                loading={this.props.loading}
              />
            </NitroButtonGroup>
          </ActionSection>
        </PasswordSection>
      </section>
    );
  }
}

const mapStateToProps = state => {
  const { loading, success } = state.userManagement.users;
  return {
    loading,
    success: success || null
  };
};
const mapDispatchToProps = dispatch => ({
  setPassword: bindActionCreators(setPassword, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/features/userManagement/ChangePassword.js